import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import {
  STAFF_STATE,
  STAGE_MASTER_STATE,
  TENANTS_INFO,
} from './../../../state/app.state';
import { Store } from '@ngrx/store';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Inject,
  LOCALE_ID,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  OpportunityResponse,
  TaskOutcomeDetails,
  TENANTSINTERFACE,
  PlanSummary,
  PlanSummaryCRM,
  PlanSummaryClient,
} from '@fitness-force/models';
import { StyleClassModule } from 'primeng/styleclass';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { AvatarModule } from 'primeng/avatar';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import {
  CdkDragDrop,
  CdkDragMove,
  DragDropModule,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { CreateOpportunityComponent } from '@fitness-force/crm';
import {
  CallOutcomeComponent,
  HotwarmcoldComponent,
  TimeLinePipe,
  timeLineService,
  TourOutcomeComponent,
  TaskCreateComponent,
  MultiSelectStaffComponent,
  AuthguardService,
  TenantResolverService,
  SharedModule,
} from '@fitness-force/shared';
import { BillingComponent } from '@fitness-force/billing';
import { LostDealComponent } from '@fitness-force/crm';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import {
  AuthSevices,
  ClientService,
  CommonService,
  OpportunityService,
  TimeconversionService,
} from '@fitness-force/api';
import { OpportunityBoardType } from '@fitness-force/enum';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';

import { ToastMessageService } from '@fitness-force/api';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientInfoSidebarComponent } from '@fitness-force/core';
import { SkeletonModule } from 'primeng/skeleton';
import { Routes, RouterModule } from '@angular/router';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { IonicModule } from '@ionic/angular';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'fitness-force-pipeline',
  templateUrl: './pipeline.component.html',
  styleUrls: ['./pipeline.component.scss'],
  providers: [ToastMessageService],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StyleClassModule,
    SelectModule,
    DialogModule,
    InputTextModule,
    AvatarModule,
    DividerModule,
    ButtonModule,
    TourOutcomeComponent,
    CallOutcomeComponent,
    HotwarmcoldComponent,
    CreateOpportunityComponent,
    LostDealComponent,
    TooltipModule,
    CurrencyformatPipe,
    TimeLinePipe,
    BillingComponent,
    DragDropModule,
    ScrollingModule,
    TaskCreateComponent,
    ClientInfoSidebarComponent,
    SkeletonModule,
    MultiSelectStaffComponent,
    SharedModule,
    ShortNamePipe,
    IonicModule,
    ToggleSwitchModule,
    CheckboxModule,
    TranslateModule,
    RouterModule
]
})
export class PipelineComponent implements OnInit {
  getAccessTenantList$: Observable<any> | any;
  tenant: any = 0;
  tenantId = 0;
  tenantAll: any;
  draggedProduct: any;
  elementDragStatus = 'drag-none';
  elementDropStatus = 'drop-none';
  showCreateOpportunityPopup: Observable<boolean> | any = false;
  dataOpportunityResponse: Observable<OpportunityResponse> | any = null;
  draggedHoverItem: any;
  listOpportunityStage$?: Observable<any>;
  listOpportunity$?: Observable<any>;
  boardData: any = new Map();
  foreCastBoardData: any = new Map();
  opportunityData$ = new BehaviorSubject<any[]>([]);
  opportunityDataForMonths$ = new BehaviorSubject<any[]>([]);
  dragStatusOnLost = 'default';
  dragStatusOnOwn = 'default';
  outcomeDetail = <TaskOutcomeDetails>{};
  showMeetingOutcomePopup: Observable<boolean> | any = false;
  showCallOutcomePopup: Observable<boolean> | any = false;
  lostDealsMap = new Map();
  showLostDealDialog = false;
  currentUrl = '';
  assigned = [];
  allStaffs: any = [];
  selectedAssigned!: any;
  opportunity = [];
  selectedOpportunity!: any;
  convertibility = [];
  selectedConvertibility!: any;
  outcome = [];
  selectedOutcome: any;
  reasons = [];
  selectedReason!: any;
  showFilterDropdown = false;
  values: string[] | undefined;
  followUpDate: Date | undefined;
  contractEndDate: Date | undefined;
  followupTime = [];
  mylookupservice: any;
  showChooseReason = false;
  showLostToCompetitors = false;
  showLostToPrice = false;
  showLostToOtherReasons = false;
  showLostNotContactable = false;
  showLosttoMissingFacility = false;
  showCalendar = false;
  lostDealItemInfo = '';
  ownDealItemInfo = '';
  allOpportunity = new BehaviorSubject<any>(0);
  //For create Task
  showTaskCreate = false;
  activeTaskOpportunity!: any;
  taskModalPopup = false;
  selectedStaffIds: any = [];
  planSummarydataObject$: BehaviorSubject<PlanSummary> = new BehaviorSubject(
    {} as PlanSummary
  );
  showPaidFullSidebar = false;
  animationFrame: number | undefined;
  showClientSidebar = false;
  activeClientId = 0;
  showSkeleton = true;
  showEmptyPipeline$ = new BehaviorSubject(false);
  showPipelineView = new BehaviorSubject<boolean>(true);
  showForecastView = new BehaviorSubject<boolean>(false);
  months$ = new BehaviorSubject([] as String[]);
  filterMonths$ = new BehaviorSubject([] as String[]);
  hideMonth:boolean=true;
  connectedDropLists :string[] = [];


  @ViewChild('Container', { read: ElementRef }) container: ElementRef | any;

  constructor(
    private store: Store,
    private opportunityService: OpportunityService,
    private clientService: ClientService,
    private authService: AuthSevices,
    private cd: ChangeDetectorRef,
    private commonService: CommonService,
    private timeService:TimeconversionService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.selectedStaffIds = JSON.parse(
      localStorage.getItem('PIPELINE_STAFF_LIST') || '[]'
    );
    if (
      this.selectedStaffIds.length == 0
    ) {
      this.selectedStaffIds.push(
        parseInt(this.authService.currentUserDetails()?.Id)
      );
    }

    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.setBoardData();
      }
    });

    if(localStorage.getItem('SelecteView_'+this.authService.currentUserDetails()?.Id))
    {
      if(localStorage.getItem('SelecteView_'+this.authService.currentUserDetails()?.Id) == 'Sales'){
        this.showPipelineView.next(true);
        this.showForecastView.next(false);
      } 
      else{
        this.showPipelineView.next(false);
        this.showForecastView.next(true);
      }
    }
    

    this.store.select(STAFF_STATE).subscribe((staffs: any) => {
      this.allStaffs = staffs.staffList;
    });

    this.commonService.newProspectCreated$.subscribe((created: boolean) => {
      if (created) {
        this.reloadAllData();
      }
    });
  }

  getStaffDetails(id: any) {
    return this.allStaffs.find((s: any) => s.id == id)
      ? this.allStaffs.find((s: any) => s.id == id)
      : '';
  }

  getBoardList() {
    this.listOpportunityStage$ = this.store.select(STAGE_MASTER_STATE);
    return this.listOpportunityStage$;
  }

  getOpportunities() {
    return (this.listOpportunity$ =
      this.opportunityService.getOpportunityService(
        this.tenantId,
        OpportunityBoardType.NewMemberBoard,
        this.getSelectedStaffIds
      ));
  }

  setBoardData() {
    this.boardData.clear();
    this.showSkeleton = true;
    const oppMaster = this.getBoardList();
    const opportunity = this.getOpportunities();

    this.opportunityData$.next([]);
    this.allOpportunity.next([]);
    this.opportunityDataForMonths$.next([]);

    this.cd.detectChanges();

    combineLatest({ oppMaster, opportunity }).subscribe((data: any) => {
      const oppMastTemp = JSON.parse(JSON.stringify(data.oppMaster));
      oppMastTemp.map((board: any) => {
        this.boardData.set(
          board.id,
          this.parseBoardData(board, data.opportunity)
        );
      });
      if(data.opportunity != null)
         this.parseForeCastData(data.opportunity);
      this.opportunityData$.next([...this.boardData.values()]);
      this.opportunityDataForMonths$.next([...this.foreCastBoardData.values()]);
      this.allOpportunity.next(data.opportunity ? data.opportunity?.length : 0);
      this.updateConnectedDropLists();
      if (data.opportunity && data.opportunity?.length > 0) {
        this.showEmptyPipeline$.next(false);
      } else this.showEmptyPipeline$.next(true);
      this.showSkeleton = false;
    });
    this.draggedProduct = '';
  }

  parseBoardData(board: any, opportunity: any) {
    const temp = opportunity
      ? opportunity.filter((opp: any) => {
          return opp && opp.stage_master_id == board.id;
        })
      : [];

    temp.sort((a: any, b: any) => {
      return b.sort_order - a.sort_order;
    });

    board.opportunity = temp;

    return board;
  }

  parseForeCastData(opportunities: any) {
    const currentDate = new Date();
    const startDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const filteredData = opportunities.filter(
      (item: { expected_closure_date: string | Date }) => {
        const closureDate = this.timeService.ConvertUTCToLocalDateTime(item.expected_closure_date);
        return closureDate >= startDate;
      }
    );
    
    let distinctMonthNames = Array.from({ length: 6 }, (_, i) => {
      const nextDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + i,
        1
      );
      return `${nextDate.toLocaleString('en-US', { month: 'long' })} ${nextDate.getFullYear()}`;
    });

    const filteredMonthNames = filteredData.map(
      (item: { expected_closure_date: string | Date }) => {
        const date = this.timeService.ConvertUTCToLocalDateTime(item.expected_closure_date);
        return `${date.toLocaleString('en-US', { month: 'long' })} ${date.getFullYear()}`;
      }
    );

    //let distinctMonthNames = [...new Set(monthNames)];
    // Create a set of unique month names and sort them in ascending order
    // let distinctMonthNames = [...new Set(monthNames)].sort((a, b) => {
    //   const dateA = new Date(
    //     filteredData.find(
    //       (item: { expected_closure_date: string  | Date }) => {
    //         const date = this.timeService.ConvertUTCToLocalDateTime(item.expected_closure_date);
    //         return `${date.toLocaleString('en-US', { month: 'long' })} ${date.getFullYear()}` === a;
    //       }
    //     ).expected_closure_date
    //   );
    //   const dateB = new Date(
    //     filteredData.find(
    //       (item: { expected_closure_date: string  | Date }) => {
    //         const date = this.timeService.ConvertUTCToLocalDateTime(item.expected_closure_date);
    //         return `${date.toLocaleString('en-US', { month: 'long' })} ${date.getFullYear()}` === b;
    //       }
    //     ).expected_closure_date
    //   );
    //   return dateA.getTime() - dateB.getTime();
    // });

    // If distinctMonthNames length is less than 3, add next six months
    if (filteredMonthNames.length <= 3) {
      const nextMonths = Array.from({ length: 6 }, (_, i) => {
        const nextDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + filteredMonthNames.length + i,
          1
        );
        return `${nextDate.toLocaleString('en-US', { month: 'long' })} ${nextDate.getFullYear()}`;
      });
      distinctMonthNames = [...distinctMonthNames, ...nextMonths];
    }

    const uniqueDateSet = new Set(distinctMonthNames);
    // Convert the Set back to an array
    distinctMonthNames = Array.from(uniqueDateSet);
    distinctMonthNames.forEach((month) => {
      this.foreCastBoardData.set(
        month,
        filteredData.filter(
          (item: { expected_closure_date: string  | Date }) => {
            const date = this.timeService.ConvertUTCToLocalDateTime(item.expected_closure_date);
            return `${date.toLocaleString('en-US', { month: 'long' })} ${date.getFullYear()}` === month;
          }
        )
      );
    });
    this.months$.next(distinctMonthNames as string[]);
    if (this.hideMonth) {
      this.filterMonths$.next(this.months$.value.filter(month => {
        const data = this.foreCastBoardData.get(month);
        return data && data.length > 0;
      }));
    } else {
      this.filterMonths$.next(this.months$.value);
    }
  }

  parseMap(opp: any) {
    return [...opp.values()];
  }

  get getAllBoardData(): Array<any> {
    return [...this.boardData.values()];
  }

  get getForcastData() {
    return [...this.foreCastBoardData.values()];
  }

  dragStart(event: any, opportunity: any) {
    this.elementDragStatus ='started border-2 border-dashed border-primary bg-blue-50';
    this.draggedProduct = opportunity;
    this.showLostDealDialog = true;
    this.dragStatusOnLost = 'default';
    this.dragStatusOnOwn = 'default';
    this.cd.detectChanges();
  }

  onClickFire(event: any, opportunity: any) {
    
  }

  onDragging(event: Event) {
    this.elementDragStatus ='dragging border-2 border-dashed border-primary bg-blue-50';
    this.elementDropStatus = 'drag-default';
  }

  onDragEnd() {
    if (this.showLostDealDialog) {
      this.dragStatusOnLost = 'default';
      this.dragStatusOnOwn = 'default';
      this.showLostDealDialog = false;
      this.cd.detectChanges();
    }
  }

  onDragEnter(event: any) {
    this.draggedHoverItem = event;
    this.elementDropStatus =
      'dragenter border-2 border-dashed border-primary bg-blue-50';
  }

  dragEnterToLostDeal(event: any) {
    this.dragStatusOnLost = 'bg-red';
    this.dragStatusOnOwn = 'default';
    this.cd.detectChanges();
  }

  dragExitFromLostDeal(event: any) {
    this.dragStatusOnLost = 'default';
    this.dragStatusOnOwn = 'default';
    this.cd.detectChanges();
  }

  dragEnterToWinDeal() {
    this.dragStatusOnLost = 'default';
    this.dragStatusOnOwn = 'bg-green-400';
    this.cd.detectChanges();
  }
  dragExitFromWinDeal() {
    this.dragStatusOnLost = 'default';
    this.dragStatusOnOwn = 'default';
    this.cd.detectChanges();
  }

  getDropStatus(id: any) {
    if (this.draggedHoverItem && this.draggedHoverItem == id)
      return this.elementDropStatus;
    return 'drag-default';
  }

  moveToLostDeal(event: CdkDragDrop<string[]>) {
    this.showChooseReason = true;
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
    const containerData = event.previousContainer.data;
    const dropedOpp: any = containerData[event.previousIndex];
    const boardData: any = this.getAllBoardData.find(
      (board: any) => board.id == dropedOpp.stage_master_id
    );

    this.lostDealItemInfo = dropedOpp;
    let OppIndex = boardData.opportunity.findIndex((o: any) => {
      return o.id === dropedOpp.id;
    });
    if (OppIndex !== -1) boardData.opportunity.splice(OppIndex, 1);
  }

  moveToWonDeal(event: CdkDragDrop<string[]>) {
    //this.showChooseReason = true
    this.showLostDealDialog = false;
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
    const containerData = event.previousContainer.data;
    const dropedOpp: any = containerData[event.previousIndex];

    const planSummary: PlanSummary = {
      id: 0,
      from_subscription_id: 0,
      client: {
        client_id: dropedOpp.client_info.id,
        client_name: dropedOpp.client_info.full_name,
        client_status: dropedOpp.client_info.status,
      } as PlanSummaryClient,
      couponcode: null,
      tenant_id: this.tenantId,
      company_id: dropedOpp.company_id,
      startdate: new Date(),
      plan_selectable: true,
      CRM: {
        opp_id: dropedOpp.id,
        task_id: dropedOpp.latest_task?.id || 0,
        board_id: dropedOpp.board_type,
      } as PlanSummaryCRM,
      Scheduling: null,
    } as PlanSummary;

    this.planSummarydataObject$.next(planSummary);
    if (dropedOpp.latest_task?.id > 0) this.taskModalPopup = true;
    else this.showPaidFullSidebar = true;
  }

  closeTaskModal(vardata: boolean) {
    let planSummary: PlanSummary = {} as PlanSummary;
    if (!vardata) {
      planSummary = this.planSummarydataObject$.value;
      planSummary.CRM.task_id = 0;
      this.planSummarydataObject$.next(planSummary);
    }
    this.taskModalPopup = false;
    this.showPaidFullSidebar = true;
  }

  cancelTaskModal() {
    this.planSummarydataObject$.unsubscribe();
    this.taskModalPopup = false;
  }

  hideBillingSummary(event?: any) {
    this.showPaidFullSidebar = false;
    this.dragStatusOnLost = 'default';
    this.dragStatusOnOwn = 'default';
    this.setBoardData();
    this.cd.detectChanges();
  }

  closeDailog() {
    this.showChooseReason = false;
    this.showLostDealDialog = false;
    this.dragStatusOnLost = 'default';
    this.dragStatusOnOwn = 'default';
    this.setBoardData();
    this.cd.detectChanges();
  }

  valueInMinorCurrency(boardId: number) {
    const boardOpportunity = this.boardData.get(boardId);
    const opportunity = boardOpportunity ? boardOpportunity.opportunity : 0;
    if (opportunity.length > 0) {
      let value = 0;
      this.parseMap(boardOpportunity.opportunity).forEach((op: any) => {
        value = value + op.value_in_minor_currency;
      });
      return value;
    } else {
      return 0;
    }
  }

  valueInMinorCurrencyForMonth(month: string) {
    const opportunity = this.foreCastBoardData.get(month);
    if (opportunity.length > 0) {
      let value = 0;
      opportunity.forEach((op: any) => {
        value = value + op.value_in_minor_currency;
      });
      return value;
    } else {
      return 0;
    }
  }

  TotalDealsForMonth(month: string) {
    const opportunity = this.foreCastBoardData.get(month);
    return opportunity.length;
  }

  dragEnd(event: any) {
    this.draggedProduct = null;
    this.elementDragStatus = 'default';
    this.elementDropStatus = 'drag-default';
  }

  dragStatus(id: number): string {
    if (this.draggedProduct && this.draggedProduct.id == id) {
      return this.elementDragStatus;
    } else {
      return 'default';
    }
  }

  hideOpportunity(event: any) {
    if (event && event.modified) {
      this.setBoardData();
    }
    this.showCreateOpportunityPopup = false;
    this.dataOpportunityResponse = null;
  }

  reloadAllData() {
    this.setBoardData();
  }

  SetOutComeDetails(event: any, opportunity: any) {
    if (opportunity?.latest_task == null || opportunity?.latest_task == undefined) {
      this.createTask(event, opportunity);
    } else {
      event.stopPropagation();
      if (opportunity?.latest_task?.assigned_to_staff_id)
        opportunity.assigned_to_staff_id =
          opportunity?.latest_task?.assigned_to_staff_id;

      this.outcomeDetail = opportunity;

      if (opportunity?.latest_task?.type.toLocaleLowerCase() == 'tour') {
        this.showMeetingOutcomePopup = true;
      } else {
        this.showCallOutcomePopup = true;
      }
    }
  }

  HideOutComePopup(event: any) {
    this.showCallOutcomePopup = false;
    this.showMeetingOutcomePopup = false;
    if (event.modified) {
      this.setBoardData();
    }
  }

  modified(event: any) {
    if (event) {
      this.setBoardData();
    }
  }

  SetOpportunityDetails(event: any, paramOpportunity: OpportunityResponse) {
    this.dataOpportunityResponse = paramOpportunity;
    this.showCreateOpportunityPopup = true;
  }

  clientStatus(client: any): string {
    if (client && client.status)
      return this.clientService.getClientStatusHtml(client.status.toString());
    else return '';
  }

  taskStatus(latest_task: any): any {
    const taskStatus =
      latest_task && latest_task.scheduled_date
        ? timeLineService(latest_task.scheduled_date).status
        : null;

    switch (taskStatus) {
      case null:
        return 'border-yellow-400';
      case 'task-overdue':
        return 'border-red';
      //return ' danger ';
      case 'no-task':
        return ' border-yellow-500  ';
      case 'task-due':
        return ' border-indigo-500  ';
      case 'new-task':
        return ' border-400  ';
      default:
        return ' border-400  ';
    }
  }

  taskStatusBackground(latest_task: any): any {
    const taskStatus =
      latest_task && latest_task.scheduled_date
        ? timeLineService(latest_task.scheduled_date).status
        : null;

    switch (taskStatus) {
      case null:
        return 'bg-yellow-50';
      case 'task-overdue':
        return 'bg-red-50';
      // return ' danger ';
      case 'no-task':
        return ' bg-yellow-50  ';
      case 'task-due':
        return ' bg-indigo-50  ';
      case 'new-task':
        return ' surface-50  ';
      default:
        return ' surface-50  ';
    }
  }

  leadsOnDrop(event: CdkDragDrop<any[]>, bId: number) {
    let dropedOpp!: any;
    const dragDown = event.currentIndex > event.previousIndex;
    //if (event.currentIndex == event.previousIndex) return;
    if (event.previousContainer.data && event.previousContainer.data.length > 0 ) {
      dropedOpp = event.previousContainer.data[event.previousIndex];
    }
    let payload = {
      "sort_order_ofaboveopportunity": 0,
      "sort_order_ofbelowopportunity": 0
    };
    if (event.previousContainer === event.container) {
      
      if (dragDown)
        payload.sort_order_ofaboveopportunity = event.container.data[event.currentIndex] ? event.container.data[event.currentIndex].sort_order: 0;
      else {
        payload.sort_order_ofaboveopportunity = event.container.data[event.currentIndex - 1]? event.container.data[event.currentIndex - 1].sort_order: 0;
      }

      if (dragDown){
        payload.sort_order_ofbelowopportunity = event.container.data[event.currentIndex + 1] ? event.container.data[event.currentIndex + 1].sort_order : 0;
      }
      else {
        payload.sort_order_ofbelowopportunity = event.container.data[event.currentIndex] ? event.container.data[event.currentIndex].sort_order : 0;
      }
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      this.opportunityService.OpportunityChangeOrderService(
          this.tenantId,
          OpportunityBoardType.NewMemberBoard,
          dropedOpp.id,
          payload
        )
        .subscribe((res: any) => {
          // this.setBoardData();
        });
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );

      if (event.container.data[event.currentIndex - 1]) {
        payload.sort_order_ofaboveopportunity =
          event.container.data[event.currentIndex - 1].sort_order;
      } else {
        payload.sort_order_ofaboveopportunity = 0;
      }
      if (event.container.data[event.currentIndex + 1]) {
        // // handling boundary condition for bottom drop
        // if((event.currentIndex+1)!==event.container.data.length){
        payload.sort_order_ofbelowopportunity = event.container.data[event.currentIndex + 1]?.sort_order;
        // }else{
        //   payload.sort_order_ofbelowopportunity =0;
        // }
      } else {
        payload.sort_order_ofbelowopportunity = 0;
      }
      // this.changeSortOrder(event, dropedOpp);
      this.opportunityService
        .OpportunityChangeStageService(
          this.tenantId,
          OpportunityBoardType.NewMemberBoard,
          dropedOpp.id,
          bId,
          payload
        )
        .subscribe((res: any) => {
          // this.setBoardData();
          // event.previousContainer.data.forEach((x: any, index) => {
          //   x.sort_order = index;
          // });
        });
      // Change sort order
    }
    // event.container.data.forEach((x: any, index) => {
    //   x.sort_order = index;
    // });
  }

  leadOnDragStart(e: any) {
    this.showLostDealDialog = true;
    this.cd.detectChanges();
  }
  leadOnDragEnter(e: any) {}

  leadOnDragRelease(e: any) {
    this.showLostDealDialog = false;
    this.cd.detectChanges();
  }
  leadOnDragEnded(e: any) {
    this.showLostDealDialog = false;
    this.cd.detectChanges();
  }
  dragMovescroll($event: CdkDragMove) {
    const { y } = $event.pointerPosition;
    const baseEl = this.container.nativeElement;
    const box = baseEl.getBoundingClientRect();
    const scrollTop = baseEl.scrollTop;
    const top = box.top + -y;
    if (top > 0 && scrollTop !== 0) {
      const newScroll = scrollTop - 10 * Math.exp(top / 50);
      baseEl.scrollTop = newScroll;
      this.animationFrame = requestAnimationFrame(() =>
        this.dragMovescroll($event)
      );
      return;
    }

    const bottom = y - box.bottom;
    if (bottom > 0 && scrollTop < box.bottom) {
      const newScroll = scrollTop + 10 * Math.exp(bottom / 50);
      baseEl.scrollTop = newScroll;
      this.animationFrame = requestAnimationFrame(() =>
        this.dragMovescroll($event)
      );
    }
  }

  displayTaskTypeIcon(opportunity: any): string {
    if (opportunity.latest_task) {
      switch (opportunity.latest_task.type) {
        case 'Call':
          return 'fa-phone';
        case 'Sms':
          return 'fa-comments';
        case 'Email':
          return 'fa-envelope';
        case 'Task':
          return 'fa-users';
        case 'Tour':
          return 'fa-map-marker-alt';
        default:
          return '';
      }
    } else return '';
  }
  createTask(event: any, opportunity: any) {
    this.activeTaskOpportunity = opportunity;
    event.stopPropagation();
    this.showTaskCreate = true;
  }

  get ClientIds(): number[] {
    if (
      this.activeTaskOpportunity &&
      this.activeTaskOpportunity.client_info &&
      this.activeTaskOpportunity.client_info.id
    )
      return [this.activeTaskOpportunity.client_info.id];
    else return [];
  }

  HideTaskCreate(event: any) {
    this.showTaskCreate = false;
    this.activeTaskOpportunity = null;
    // TODO: get task created information in event than reload
    this.setBoardData();
  }
  taskCreated(event: any) {
    // Refresh page not working .. .
    this.setBoardData();
  }

  get getSelectedStaffIds(): Array<any> {
    const values: any = [];
    this.selectedStaffIds.forEach((elm: any) => {
      values.push({ name: 'staff_ids', value: elm });
    });
    return values;
  }

  selectedStaffsData(staffs: any) {
    this.selectedStaffIds = [];
    staffs.forEach((s: any) => {
      this.selectedStaffIds.push(s.id);
    });
    localStorage.setItem(
      'PIPELINE_STAFF_LIST',
      JSON.stringify(this.selectedStaffIds)
    );
    this.reloadAllData();
  }

  GoToClientDetails(event: any) {
    this.activeClientId = event.clientId;
    this.showClientSidebar = true;
  }

  openClientDetails(event:any)
  {
    this.activeClientId = event.clientid;
    this.showClientSidebar = event.openclientsidebar;
  }

  closeSidebar(event: any) {
    this.showClientSidebar = false;
  }

  numSequence(n: number): Array<number> {
    return Array(n);
  }

  ChangeView(pipelineView:boolean, forcastview:boolean)
  {
    this.showSkeleton = true;
    this.showPipelineView.next(!pipelineView);
    this.showForecastView.next(!forcastview);
    if(this.showPipelineView.value){
      localStorage.setItem('SelecteView_'+this.authService.currentUserDetails()?.Id, "Sales")
    } 
    else{
      localStorage.setItem('SelecteView_'+this.authService.currentUserDetails()?.Id, "ForeCast")
    }
    setTimeout(() => {
      this.showSkeleton = false;
      this.cd.detectChanges();
    }, 10);
  }

  filterData(event:any)
  {
    if (event.checked) {
      this.filterMonths$.next(this.months$.value.filter(month => {
        const data = this.foreCastBoardData.get(month);
        return data && data.length > 0;
      }));
    } else {
      this.filterMonths$.next(this.months$.value);
    }
  }

  updateConnectedDropLists() {
    for (let i = 0; i < this.opportunityData$.value.length + 2; i++) {
      this.connectedDropLists[i] = `cdk-drop-list-${i}`;
    }
  }

}

const routes: Routes = [
  {
    path: '',
    component: PipelineComponent,
    canActivate: [AuthguardService],
    resolve: { data: TenantResolverService },
    data: {
      title: 'Sales Pipeline',
    },
  },
];
